// File: src/components/BottomNavigation.js
// Purpose: Bottom navigation component - updated for Redux Toolkit
// Last modified: 2025-11-06

import './bottomNavigation.scss';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import Paper from '@mui/material/Paper';
import React, { useState, useEffect } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SearchIcon from '@mui/icons-material/Search';
import Person from '@mui/icons-material/Person';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../store/slices/userSlice';

const MobileNavigation = () => {
    const pathname = window.location.pathname;
    const [selected, setSelected] = useState(pathname);
    const navigate = useNavigate();

    // FIXED: Use new Redux Toolkit selector instead of direct state access
    const user = useSelector(selectUser);

    const showLabel = !!(user && user.isAdmin);

    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    const currentScrollY = window.scrollY;
                    const scrollHeight = document.documentElement.scrollHeight;
                    const clientHeight = document.documentElement.clientHeight;
                    const isAtBottom = scrollHeight - (currentScrollY + clientHeight) <= 50;
                    const isAtTop = currentScrollY <= 10;

                    // Show at top, bottom, or when scrolling up
                    if (isAtTop || isAtBottom || currentScrollY < lastScrollY) {
                        setIsVisible(true);
                    } else {
                        setIsVisible(false);
                    }

                    setLastScrollY(currentScrollY);
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    return (
        <div className={`bottom-nav ${isVisible ? 'visible' : 'hidden'}`}>
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                <BottomNavigation
                    value={selected}
                    onChange={(value, newValue) => {
                        setSelected(newValue);
                    }}
                    style={{ width: '100%' }}
                    showLabels={showLabel}
                >
                    <BottomNavigationAction
                        label='Bosh sahifa'
                        icon={<HomeIcon />}
                        to=''
                        value='/'
                        onClick={() => navigate('/')}
                    />
                    <BottomNavigationAction
                        label='Narxlar'
                        onClick={() => navigate('/narxlar')}
                        to='/narxlar'
                        value='/narxlar'
                        icon={<InfoIcon />}
                    />
                    <BottomNavigationAction
                        label='Izlash'
                        onClick={() => navigate('/izlash')}
                        to='/izlash'
                        value='/izlash'
                        icon={<SearchIcon />}
                    />
                    <BottomNavigationAction
                        label='Saqlangan'
                        to='/saved'
                        value='/saved'
                        onClick={() => navigate('/saved')}
                        icon={<FavoriteIcon />}
                    />
                    {user && user.isAdmin && (
                        <BottomNavigationAction
                            label='Admin'
                            to='/admin/users/search'
                            value='/admin/users/search'
                            onClick={() => {
                                navigate('/admin/users/search');
                            }}
                            icon={<AdminPanelSettingsIcon />}
                        />
                    )}
                    <BottomNavigationAction
                        label='Sozlanmalar'
                        to='/sozlanmalar'
                        value='/sozlanmalar'
                        onClick={() => navigate('/sozlanmalar')}
                        icon={<Person />}
                    />
                </BottomNavigation>
            </Paper>
        </div>
    );
};

export default MobileNavigation;
